import axios from "axios";

import config from "../config";

const ENDPOINT_TESTING_SERVER = `${config.apiUrl}/siteTesting`;

export const checkTrackingCamera = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/trackingCamera/`
    );
    return response && response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkScoreCamera = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/scoreCamera/`
    );
    return response && response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkSpeedtest = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/speedTest/`
    );
    return response && response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkIsOnline = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/isOnline`
    );
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkAppStatus = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/appStatus`
    );
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkCamerasInternalIps = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/camerasInternalIps`
    );
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkCamerasRtspPorts = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/camerasRtspPorts`
    );
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkLive = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/liveTest`
    );
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkRecord = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/recordTest`
    );
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkCommunicationFile = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/communicationFile`
    );
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkDnsIpCompare = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/dnsIpCompare`
    );
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkExternalPorts = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/externalPorts`
    );
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkDockerImages = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/dockerImages`
    );
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkOutsideAccess = async siteId => {
  const TEST_URL_1 = "https://ipinfo.io/ip";
  const TEST_URL_2 = "https://github.com";
  try {
    const apiResponse = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/outsideAccess?site=https://api.myplay.com`
    );

    const ipInfoResponse = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/outsideAccess?site=${TEST_URL_1}/`
    );

    const githubResponse = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/outsideAccess?site=${TEST_URL_2}`
    );

    const cdnResponse = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/cdnCommunication`
    )

    const liveBroadcastResponse = await axios.get(
        `${ENDPOINT_TESTING_SERVER}/site/${siteId}/checkLiveBroadcast`
    )

    return {
      outSideAccess: {
        api: apiResponse.data.hasAccess,
        [TEST_URL_2]: githubResponse.data.hasAccess,
        [TEST_URL_1]: ipInfoResponse.data.hasAccess,
        cdn: cdnResponse.data.CDN,
        liveBroadcast: liveBroadcastResponse.data.liveStatus
      }
    };
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkSshConnection = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/sshConnection`
    );
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkVersions = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/versions/`
    );
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const checkDisplayDongleExist = async siteId => {
  try {
    const response = await axios.get(
      `${ENDPOINT_TESTING_SERVER}/site/${siteId}/checkDisplayDongleExist`
    );
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const getSiteInfo = async siteId => {
  try {
    let res = {};
    const checks = await Promise.all(
      [
        checkAppStatus(siteId),
        checkCamerasInternalIps(siteId),
        checkCamerasRtspPorts(siteId),
        checkExternalPorts(siteId),
        checkCommunicationFile(siteId),
        checkOutsideAccess(siteId),
        checkDnsIpCompare(siteId),
        checkSshConnection(siteId),
        checkVersions(siteId),
        checkTrackingCamera(siteId),
        checkScoreCamera(siteId),
        checkDisplayDongleExist(siteId)
      ].map(p => p.catch(e => e))
    );
    const validChecks = checks.filter(result => !(result instanceof Error));
    validChecks.map(check => {
      res[Object.keys(check)[0]] = Object.values(check)[0];
    });
    return res;
  } catch (e) {
    throw new Error(e);
  }
};
